export default __webpack_public_path__ + "static/media/Questions.75aec1bd.png";